import { stringIds as s } from "@amzn/ziggy-asset";
import { bundleIds as b } from "@amzn/ziggy-asset";

export const stringIds = s;
export const bundleIds = b;
